import React from "react";
import Editor from "@app/components/report-document/editor";
import "../styles/docx-import-modal.scoped.scss";

const SectionPreview = ({ section }) => (
    <div className="section-preview">
        <Editor
            contentClassName="section-preview-content"
            value={section.content}
            readonly
            onEditorReady={() => {}}
            isPreviewMode={true}
        />
    </div>
);

export default SectionPreview;
